import { render, staticRenderFns } from "./valoracion-plenaria-snp.vue?vue&type=template&id=cb57ddee&"
import script from "./valoracion-plenaria-snp.component.ts?vue&type=script&lang=ts&"
export * from "./valoracion-plenaria-snp.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports